import script from "./UmumPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UmumPage.vue?vue&type=script&setup=true&lang=js"

import "./UmumPage.vue?vue&type=style&index=0&id=507e1966&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-507e1966"]])

export default __exports__